<template>
  <div class="main">
    <div v-if="loading" class="loading-overlay-start">
      <div class="loading-gif"></div>
      <p style="color: white; margin-top: 16px;">Iniciando sistema...</p>
    </div>

    <div class="wrapper">
      <h1>Como podemos te ajudar hoje?</h1>
      <div class="itens" style="justify-content: center">
        <router-link to="/debito">
          <div class="box">
            <img :src="icDebitoveicular" />
            <p>Débitos Veiculares <span></span></p>
          </div>
        </router-link>

        <router-link to="/boleto">
          <div class="box l2">
            <img :src="icBoleto" />
            <p>Boletos <span></span></p>
          </div>
        </router-link>
      </div>

      <router-link to="/suporte">
        <span><img :src="icSuporte" />Dúvidas? Fale conosco!</span>
      </router-link>
      <FooterGlobal></FooterGlobal>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import FooterGlobal from '@/components/Footer.vue'

// IMAGES
import debitoveicular from '@/assets/svg/ic-debitoveicular.svg'
import boleto from '@/assets/svg/ic-boleto.svg'
import pix from '@/assets/svg/ic-pix.svg'
import loteria from '@/assets/svg/ic-loteria.png'
import recarga from '@/assets/svg/ic-recarga.svg'
import outros from '@/assets/svg/ic-outros.svg'
import suporte from '@/assets/svg/ic-suporte.svg'

import { post } from '@/services/requests'
import { version } from '@/helper/vars'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { iniciarPinpad } from '@/pinpad/iniciarpinpad'
import { verificarPendencia } from '@/pinpad/verificarpendencia'

export default defineComponent({
  name: 'HomePage',
  components: {
    FooterGlobal,
  },
  data() {
    return {
      icDebitoveicular: debitoveicular,
      icBoleto: boleto,
      icPix: pix,
      icLoteria: loteria,
      icRecarga: recarga,
      icOutros: outros,
      icSuporte: suporte,
      loading: false,
      versionCheckInterval: null,
    }
  },
  async mounted() {
  
    await this.iniciarSistemaPinpad()
    
    this.versionCheckInterval = setInterval(async () => {
      try {
        const response = await axios.get('https://hpay.adaga.cc/config/')
        if (response.status === 200) {
          if (response.data.version && response.data.version !== version) {
            window.location.reload(true)
          } else {
            console.log('atualizado')
          }
        }
      } catch (error) {
        console.error('Erro ao verificar versão:', error)
      }
    }, 60000 * 5)
  },
  beforeUnmount() {
    if (this.versionCheckInterval) {
      clearInterval(this.versionCheckInterval)
    }
  },
  methods: {
    async iniciarSistemaPinpad() {
      const jaIniciou = sessionStorage.getItem('pinpadIniciado')

      if (jaIniciou) {
        console.log('Sistema PinPad já foi iniciado nesta sessão')
        return
      }

      this.loading = true 

      try {
        console.log('Iniciando PinPad...')
        const resultadoInit = await iniciarPinpad()
        console.log('PinPad iniciado:', resultadoInit)

        console.log('Verificando pendências...')
        const resultadoPendencia = await verificarPendencia()
        console.log('Pendências verificadas:', resultadoPendencia)

        sessionStorage.setItem('pinpadIniciado', 'true')


      } catch (error) {
        console.error('Erro ao iniciar sistema PinPad:', error)
      } finally {
        this.loading = false
      }
    },

    async avançar() {
      const router = useRouter()
      this.loading = true
      try {
        await this.jogosSorte()
        this.loading = false
        router.push('/sorte')
      } catch (error) {
        console.error('Erro ao tentar avançar:', error)
      } finally {
        this.loading = false
      }
    },

    async jogosSorte() {
      try {
        let response = await post('/sorteOnlineGetProducts.php')

        if (response.data) {
          sessionStorage.setItem(
            'jogosDisponiveis',
            JSON.stringify(response.data),
          )
          this.$router.push('/sorte')
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
})
</script>